import React from 'react'
import styled from 'styled-components'

import FlightHeader from './components/FlightHeader.js'
import FlightInformation from './components/FlightInformation.js'
import FlightSummary from './components/FlightSummary.js'
import InvalidFlightInfo from './components/InvalidFlightInfo.jsx'

const InnerLayoutStyled = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const ScrollableContent = styled.div`
  overflow-y: auto;
  position: relative;
`

export const FlightDetailsWidgetDesktop = ({ className, T, state, onCloseClicked, onGetDirectionClick }) => {
  const {
    flightInfo
  } = state

  if (!flightInfo) return <InvalidFlightInfo T={T} onCloseClicked={onCloseClicked}/>

  return (
    <InnerLayoutStyled className={className} data-cy='FlightDetailsWidgetDesktop'>
      <FlightHeader T={T} flightInfo={flightInfo} onCloseClicked={onCloseClicked} onGetDirectionClick={onGetDirectionClick} />
      <ScrollableContent>
        <FlightSummary flightInfo={flightInfo} />
        <FlightInformation flightInfo={flightInfo} />
      </ScrollableContent>
    </InnerLayoutStyled>
  )
}

export default FlightDetailsWidgetDesktop
